import { useState } from "react";
import { VIDEOS, VideoItem } from "./trainingData";

export default function TrainingTab() {
  const [activeVideoUrl, setActiveVideoUrl] = useState<string | null>(null);
  const [modalTitle,     setModalTitle]     = useState("");

  const openVideo = (video: VideoItem) => {
    if (!video.url) return;
    const sep = video.url.includes("?") ? "&" : "?";
    setActiveVideoUrl(video.url + sep + "autoplay=1");
    setModalTitle(video.title);
  };

  const closeModal = () => {
    setActiveVideoUrl(null);
    setTimeout(() => setModalTitle(""), 150);
  };

  return (
    <>
      <div className="sh-training">
        <div className="sh-training__header">
          <div className="sh-training__header-title">Training Material</div>
          <div className="sh-training__header-sub">
            Video guides for using AI Ready Ohio. New content added regularly.
          </div>
        </div>

        <div className="sh-video-grid">
          {VIDEOS.map((v, i) => (
            <div key={i} className="sh-video-card">
              <button
                className="sh-video-card__thumb"
                onClick={() => openVideo(v)}
                disabled={!v.url}
              >
                {v.thumbnailUrl ? (
                  <img src={v.thumbnailUrl} alt={v.title} />
                ) : (
                  <div className="sh-video-card__placeholder">
                    <i className="fas fa-film sh-video-card__film-icon" />
                    <span className="sh-video-card__coming-soon">Coming Soon</span>
                  </div>
                )}
                {v.url && (
                  <span className="sh-video-card__play-btn">
                    <i className="fas fa-play" />
                  </span>
                )}
              </button>

              <div className="sh-video-card__body">
                <div className="sh-video-card__title">{v.title}</div>
                <div className="sh-video-card__desc">{v.description}</div>
                <div className="sh-video-card__duration">
                  <span className="sh-video-card__duration-label">Duration </span>
                  {v.duration}
                </div>
                <div className="sh-video-card__actions">
                  {v.url ? (
                    <button className="sh-video-card__watch-btn" onClick={() => openVideo(v)}>
                      <i className="fas fa-play" /> Watch
                    </button>
                  ) : (
                    <button className="sh-video-card__watch-btn sh-video-card__watch-btn--disabled" disabled>
                      <i className="fas fa-clock" /> Coming Soon
                    </button>
                  )}
                  {v.jobAidUrl && (
                    <a className="sh-video-card__aid-btn" href={v.jobAidUrl} download>
                      <i className="fas fa-file-arrow-down" /> Job Aid
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      {activeVideoUrl && (
        <div className="sh-modal-overlay" onClick={closeModal}>
          <div className="sh-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sh-modal__topbar">
              <span className="sh-modal__topbar-title">{modalTitle}</span>
              <button className="sh-modal__close" onClick={closeModal}>
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="sh-modal__iframe-wrap">
              <iframe
                src={activeVideoUrl}
                title={modalTitle}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
